module.exports = __webpack_public_path__ + "static/media/template_update_HP_and_BP.5e12e3c6.xlsx";